import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer, Text, View } from "@components";

type Props = PropsFromLocalize;

const HelpPanelEmployeeAbsences = (props: Props) => {
  const { t } = props;

  const columns = [
    {
      title: t("ITEM"),
      name: "item",
      width: 110,
      renderItem: item => item.label,
    },
    {
      title: t("DESCRIPTION"),
      name: "details",
      renderItem: item => item.details,
    },
  ];

  const dateDefinitionsData = [
    {
      id: "start-date",
      label: t("START_DATE"),
      details: t("START_DATE_DEFINITION"),
    },
    {
      id: "last-absence",
      label: t("LAST_ABSENT_DAY"),
      details: t("LAST_ABSENCE_DAY_DEFINITION"),
    },
    {
      id: "rtw-date",
      label: t("RTW_DATE"),
      details: t("RTW_DATE_DEFINITION"),
    },
    {
      id: "date-reported",
      label: t("DATE_REPORTED"),
      details: t("DATE_REPORTED_DEFINITION"),
    },
    {
      id: "fit-date",
      label: t("FIT_DATE"),
      details: t("FIT_DATE_DEFINITION"),
    },
  ];

  return (
    <View>
      <View margin="0.25rem 0 1rem 0">
        <WistiaPlayer
          videoId={WistiaPlayer.videos.EMPLOYEE_ABSENCES_INSTRUCTIONS}
          title={t("ABSENCE_ADMIN")}
        />
      </View>
      <Text type="h6">{t("DATE_DEFINITIONS")}</Text>
      <SimpleGrid className="theme-help" columns={columns} rows={dateDefinitionsData} />
    </View>
  );
};

export default localize()(HelpPanelEmployeeAbsences);
